export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-07.1d7549f3.jpg";